/**
 * Segmented-control tab for the "top spend" mode selector. Extracted from Products.jsx.
 */
export function ModeTab({ value, current, onClick, children }) {
  const active = value === current;
  return (
    <button
      type="button"
      onClick={() => onClick(value)}
      data-testid={`products-top-mode-${value}`}
      className={`px-3 py-1.5 text-xs font-medium transition-colors ${
        active
          ? "bg-[var(--brand-accent)] text-white"
          : "bg-[var(--surface)] hover:bg-[var(--surface-hover)] text-[var(--text-secondary)]"
      }`}
    >
      {children}
    </button>
  );
}
